import React from 'react';
import '../../styles/components/AsperaTearsheet.scss';
import { AsperaError } from '../../classes/AsperaError';
import { AsperaPageHeader } from '../AsperaPageHeader';
import { SubManager } from '../../classes/SubManager';
import { observableTimeout } from '../../helpers/starterHelpers';
import { Button, getIconComponent } from '../Carbon';
import { language } from '../../services/LanguageService';
/**
 * React Component
 *
 * The AsperaTearsheet renders the tabs via a simple array
 *
 * @example
 * ```javascript
 * <AsperaTearsheet content={this.content} />
 * ```
 */
export const AsperaTearsheet = class AsperaTearsheet extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            movedUp: false,
        };
        this.subManager = new SubManager();
        this.moveUpView = () => {
            this.setState({ movedUp: true });
        };
        this.moveDownView = () => {
            const { onClose } = this.props;
            this.setState({ movedUp: false });
            this.subManager.setSubscription(observableTimeout(350).subscribe({
                next: () => {
                    if (typeof onClose === 'function') {
                        onClose();
                    }
                },
                error: () => {
                    if (typeof onClose === 'function') {
                        onClose();
                    }
                },
            }));
        };
    }
    componentDidCatch(error) {
        new AsperaError('AsperaTearsheet: Encountered exception from children', error);
        this.setState({});
    }
    componentDidMount() {
        this.subManager.setSubscription(observableTimeout(100).subscribe({
            next: this.moveUpView,
            error: this.moveUpView,
        }));
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { className, headerData, content, onClose } = this.props;
        const { movedUp } = this.state;
        return (React.createElement("div", { className: "aspera-tearsheet--wrapper" },
            React.createElement("div", { className: `aspera-tearsheet ${className ? className : ''} ${movedUp ? 'moved-up' : ''}`, "data-auto": "tearsheet-wrapper" },
                !!onClose && React.createElement(Button, { key: "close", className: "close-action", tabIndex: 0, hasIconOnly: true, iconDescription: language.get('modal.close'), kind: "ghost", onClick: this.moveDownView, renderIcon: getIconComponent('Close'), tooltipAlignment: "center", tooltipPosition: "left" }),
                !!headerData && React.createElement(AsperaPageHeader, Object.assign({}, headerData, { className: "aspera-tearsheet--header" })),
                React.createElement("div", { className: "aspera-tearsheet--content" }, content))));
    }
};
